import { styled } from 'baseui'

export const LayoutContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: '#fff',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
})

export const ContentWrapper = styled('div', {
  display: 'flex',
  width: '100%',
  boxSizing: 'border-box',
  gap: '2rem',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
})

export const LeftColumn = styled('div', {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
})

export const RightColumn = styled('div', {
  flex: 1,
})

export const SaleFormContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: '100%',
  boxSizing: 'border-box',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  backgroundColor: '#fff',
})

export const TopHeaderContainer = styled('div', {
  width: '100%',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '0.2rem',
  flexGrow: 1,
})

export const TopHeaderBar = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 0 0 0.6rem',
  gap: '1rem',
})

export const TopHeaderMessages = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  gap: '0.25rem',
  marginTop: '0.5rem',
})

export const Breadcrumb = styled('div', {
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',
  color: '#6B7280',
  flexShrink: 0,
})

export const BreadcrumbItem = styled('div', ({ $backgroundColor, $color }) => ({
  padding: '4px 12px',
  borderRadius: '9999px',
  fontSize: '14px',
  fontWeight: 600,
  backgroundColor: $backgroundColor || '#f3f4f6',
  color: $color || '#374151',
}))
